import { Box, Typography } from "@mui/material";
import PageTitle from "../../../components/Accessibility/PageTitle";
import './styles.css';
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { sxOption } from "./sxProps";
import { getManuaisPlanoEmpresa } from "../../../services/MeuPlano/ManualUsoPlanoService";
import LoadingApp from "../../../components/LoadingApp";
import { ModalFeedBackProps } from "../../../interfaces/props/ModalFeedBackProps";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { base64toBlob } from "../../../utils/Base64ToBlob";

const ManualUsoPlano: React.FC = () => {
    const accessibility = useAccessibility();
    const cardConstrastStyle = { ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility };

    const [planoGrupoMunicipios, setPlanoGrupoMunicipios] = useState<string>('');
    const [planoNacional, setPlanoNacional] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [modalFeedback, setModalFeedback] = useState<null | ModalFeedBackProps>(null);

    useEffect(() => {
        setLoading(true)
        getManuaisPlanoEmpresa().then(response => {
            setPlanoGrupoMunicipios(response.planoGrupoMunicipios);
            setPlanoNacional(response.planoNacional);
        }).catch(() => {
            setModalFeedback({
                icon: 'error',
                handleShowModal: () => setModalFeedback(null),
                title: 'Erro ao obter manuais',
                subTitle: 'Ocorreu um erro ao obter os manuais',
                textButton: '',
                showModal: true
            })
        }).finally(() => setLoading(false))
    }, []);

    const openBase64 = (data: string) => {
        if (data) {
            const blob = base64toBlob(data.split(',')[1]);
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl);
        }
    };

    return (
        <div className="page-container">
            <PageTitle text="Manual de uso do plano" />
            <Box
                className="palestras-eventos-content"
                role="group"
                aria-label="Grupo de botões 2 itens"
                >
                <div
                    style={cardConstrastStyle}
                    className="palestras-eventos-option"
                    tabIndex={0}
                    onClick={() => openBase64(planoNacional)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            openBase64(planoNacional);
                        }
                    }}
                >
                    <Typography style={accessibility.textStyleAccessibility} sx={sxOption}>
                        Manual do beneficiário nacional
                    </Typography>
                    <FontAwesomeIcon icon={faChevronRight} />
                </div>
                <div
                    style={cardConstrastStyle}
                    className="palestras-eventos-option"
                    tabIndex={0}
                    onClick={() => openBase64(planoGrupoMunicipios)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            openBase64(planoGrupoMunicipios);
                        }
                    }}
                >
                    <Typography style={accessibility.textStyleAccessibility} sx={sxOption}>
                        Manual do beneficiário regional
                    </Typography>
                    <FontAwesomeIcon icon={faChevronRight} />
                </div>
            </Box>
            <LoadingApp showLoading={loading} text={'Carregando...'} />
            <ModalFeedBack
                showModal={!!modalFeedback}
                handleShowModal={modalFeedback?.handleShowModal}
                title={modalFeedback?.title as string}
                subTitle={modalFeedback?.subTitle as string}
                icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
                showButtonModal={modalFeedback?.showButtonModal}
                textButton={modalFeedback?.textButton as string}
                handleButtonModal={modalFeedback?.handleButtonModal}
                classNameModal="modal-custom"
            />
        </div>
    );
};

export default ManualUsoPlano;
